import React from "react";
import PropTypes from "prop-types";

const FormGroupWithError = ({ children, errorText, errorClassName = "", groupClassName = "" }) => (
    <div className={"form-group " + (errorText && "has-error") + " " + groupClassName}>
        {children}
        {errorText && <span className={errorClassName + " help-block"}>{errorText}</span>}
    </div>
);

FormGroupWithError.propTypes = {
    children: PropTypes.node,
    errorText: PropTypes.string,
    errorClassName: PropTypes.string,
    groupClassName: PropTypes.string,
};
export default FormGroupWithError;
